import { render, staticRenderFns } from "./trawl-admin-layout.vue?vue&type=template&id=b4db7010"
import script from "./trawl-admin-layout.vue?vue&type=script&lang=js"
export * from "./trawl-admin-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports